// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"LeaveConfirmationModal_buttonsContainer__+ZzI+"};